module.exports = __webpack_public_path__ + "static/media/u-turn.302b7c10.svg";